module.exports = "../content/7378d9774fa42af45f0b9958b6e3ddb4.woff2";